import {
  checkVAT,
  austria,
  australia,
  belgium,
  bulgaria,
  croatia,
  cyprus,
  czechRepublic,
  denmark,
  estonia,
  finland,
  france,
  germany,
  greece,
  hungary,
  ireland,
  italy,
  latvia,
  lithuania,
  luxembourg,
  malta,
  netherlands,
  norway,
  poland,
  portugal,
  romania,
  slovakiaRepublic,
  slovenia,
  spain,
  sweden,
  switzerland,
  unitedKingdom
} from 'jsvat-next'

const COUNTRY_TO_VAT_CHECKER: Record<string, (vat: string) => boolean> = {
  // EU Countries
  AT: vat => checkVAT(vat, [austria]).isValid,
  BE: vat => checkVAT(vat, [belgium]).isValid,
  BG: vat => checkVAT(vat, [bulgaria]).isValid,
  HR: vat => checkVAT(vat, [croatia]).isValid,
  CY: vat => checkVAT(vat, [cyprus]).isValid,
  CZ: vat => checkVAT(vat, [czechRepublic]).isValid,
  DK: vat => checkVAT(vat, [denmark]).isValid,
  EE: vat => checkVAT(vat, [estonia]).isValid,
  FI: vat => checkVAT(vat, [finland]).isValid,
  FR: vat => checkVAT(vat, [france]).isValid,
  DE: vat => checkVAT(vat, [germany]).isValid,
  GR: vat => checkVAT(vat, [greece]).isValid,
  HU: vat => checkVAT(vat, [hungary]).isValid,
  IE: vat => checkVAT(vat, [ireland]).isValid,
  IT: vat => checkVAT(vat, [italy]).isValid,
  LV: vat => checkVAT(vat, [latvia]).isValid,
  LT: vat => checkVAT(vat, [lithuania]).isValid,
  LU: vat => checkVAT(vat, [luxembourg]).isValid,
  MT: vat => checkVAT(vat, [malta]).isValid,
  NL: vat => checkVAT(vat, [netherlands]).isValid,
  PL: vat => checkVAT(vat, [poland]).isValid,
  PT: vat => checkVAT(vat, [portugal]).isValid,
  RO: vat => checkVAT(vat, [romania]).isValid,
  SK: vat => checkVAT(vat, [slovakiaRepublic]).isValid,
  SI: vat => checkVAT(vat, [slovenia]).isValid,
  ES: vat => checkVAT(vat, [spain]).isValid,
  SE: vat => checkVAT(vat, [sweden]).isValid,

  // Non-EU (jsvat-next built-in)
  AU: vat => checkVAT(vat, [australia]).isValid,
  CH: vat => checkVAT(vat, [switzerland]).isValid,
  GB: vat => checkVAT(vat, [unitedKingdom]).isValid,
  NO: vat => checkVAT(vat, [norway]).isValid,

  // Non-EU (custom regex)
  AE: vat => /^\d{15}$/.test(vat),
  JP: vat => /^T\d{13}$/.test(vat),
  KR: vat => /^\d{3}-\d{2}-\d{5}$/.test(vat),
  NZ: vat => /^\d{8,9}$/.test(vat),
  SG: vat => /^[A-Z0-9]{9,10}$/.test(vat),
  TH: vat => /^\d{13}$/.test(vat)
}

type Messages = {
  vatNotSupported: string
  notValid: string
}

export function vatValidation(country: string, messages: Messages) {
  return (vat: string) => {
    if (!vat) return

    const checker = COUNTRY_TO_VAT_CHECKER[country]

    if (!checker) return messages.vatNotSupported

    const isValid = checker(vat.toUpperCase())

    return isValid ? undefined : messages.notValid
  }
}
